import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PasswordManagementService {
	constructor(private functions: AngularFireFunctions) {}

	adminSetPassword(
		targetUserId: string,
		password: string,
		forcePasswordChange: boolean = true
	): Promise<{ success: boolean; mustChangePassword: boolean }> {
		const callable = this.functions.httpsCallable('user-adminSetPassword');
		return firstValueFrom(callable({
			targetUserId,
			password,
			forcePasswordChange
		})) as Promise<{ success: boolean; mustChangePassword: boolean }>;
	}

	completePasswordChange(): Promise<{ success: boolean }> {
		const callable = this.functions.httpsCallable('user-completePasswordChange');
		return firstValueFrom(callable({})) as Promise<{ success: boolean }>;
	}
}
